if (!customElements.get('video-reels-slider')) {
  customElements.define('video-reels-slider', class extends HTMLElement {
    connectedCallback() {
      this.swiperContainer = this.querySelector('.swiper');
      this.modal = this.querySelector('.reel-video-modal');
      this.modalPlayer = this.querySelector('.reel-modal-player');
      this.closeBtn = this.querySelector('.reel-video-modal-close');
      this.overlay = this.querySelector('.reel-video-modal-overlay');
      this.videos = this.querySelectorAll('.reel-video[data-autoplay="true"]');
      this.initSwiper();
      this.initObserver();
      this.initSoundToggles();
      this.initModalEvents();
    }

    initSwiper() {
      if (!this.swiperContainer || !window.SwiperReady) return;
      const self = this;
      window.SwiperReady(function () {
        self.swiperInstance = new Swiper(self.swiperContainer, {
          slidesPerView: 3.1,
          spaceBetween: 8,
          grabCursor: true,
          breakpoints: {
            1024: {
              slidesPerView: 3.6,
              spaceBetween: 10
            }
          }
        });
      });
    }

    initObserver() {
      if (!('IntersectionObserver' in window) || this.videos.length === 0) return;

      const hidePoster = (videoEl) => {
        const poster = videoEl.parentElement && videoEl.parentElement.querySelector('.reel-poster');
        if (poster) poster.classList.add('is-hidden');
      };

      this.videos.forEach((vid) => {
        if (vid._posterBound) return;
        vid._posterBound = true;
        vid.addEventListener('playing', () => hidePoster(vid), { once: true });
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.5 });

      this.videos.forEach((vid) => this.observer.observe(vid));
    }

    toggleSound(container) {
      const video = container.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.muted) video.play().catch(() => {});
      const btn = container.querySelector('.reel-mute');
      if (!btn) return;
      btn.classList.toggle('is-unmuted', !video.muted);
      btn.setAttribute('aria-pressed', String(video.muted));
      btn.setAttribute('aria-label', video.muted ? btn.dataset.unmuteLabel : btn.dataset.muteLabel);
    }

    initSoundToggles() {
      this.querySelectorAll('.reel-video-container').forEach((container) => {
        container.addEventListener('click', () => this.toggleSound(container));
        const btn = container.querySelector('.reel-mute');
        if (!btn) return;
        btn.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleSound(container);
        });
      });
    }

    initModalEvents() {
      if (!this.modal || !this.modalPlayer) return;
      const closeModal = () => {
        this.modal.classList.remove('is-active');
        this.modal.setAttribute('aria-hidden', 'true');
        this.modalPlayer.pause();
        this.modalPlayer.innerHTML = '';
        this.modalPlayer.load();
      };
      this.closeBtn.addEventListener('click', closeModal);
      this.overlay.addEventListener('click', closeModal);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.swiperInstance) this.swiperInstance.destroy();
    }
  });
}
